export interface PatientAuditLog {
  PatientCode: string;
  ColumnName: string;
  OldValue: string;
  NewValue: string;
  ChangedByName: string;
  ChangeDate: Date;
}